import React from 'react';
import LegalLayout from '../components/common/LegalLayout';

const LearningGuidePage = () => (
  <LegalLayout
    title="학습 가이드"
    subtitle="처음 신청하는 분들을 위해, 학습이 어떤 흐름으로 진행되는지 정리했습니다."
    helmetDescription="ElectroWave Club 학습 가이드 — 1:1 멘토 매칭과 프로젝트 중심 학습이 진행되는 주간 흐름과 학습 환경을 안내합니다."
    accentColor="#6366f1"
  >
    <h2>1. 한 주의 흐름</h2>
    <p>
      ElectroWave Club은 "주간 사이클"을 기본 단위로 학습합니다. 한 주가 끝날 때마다 작은 결과물이 하나씩
      쌓이도록 일정과 목표를 짜는 방식입니다.
    </p>
    <ul>
      <li><strong>주초 (월/화)</strong> — 그 주의 목표 정리, 사전 학습 자료 점검</li>
      <li><strong>주중 비동기 (수/목)</strong> — 학생이 코드 작업, 막힌 곳은 채팅으로 멘토에게 질문</li>
      <li><strong>주말 정기 미팅 (60분, 월 4회)</strong> — 작성한 코드 리뷰 + 페어 프로그래밍 + 다음 주 목표 설정</li>
    </ul>
    <p>
      개인 사정에 맞춰 요일과 시간대를 조정할 수 있습니다. 정기 미팅은 화상으로 진행되며, <strong>Zoom을
      사용하여 진행합니다.</strong> <strong>녹화본은 기본적으로 남깁니다.</strong> 녹화본은 <strong>학생
      본인의 자료 정리·복습 목적으로만</strong> 사용되며, <strong>외부 공개·제3자 공유·재배포는 하지
      않습니다.</strong> 멘토 또한 동일한 의무를 준수합니다.
    </p>

    <h2>2. 권장 학습 시간</h2>
    <p>
      과정 난이도와 본인의 페이스에 따라 다르지만, 평균적으로 다음 정도를 권장합니다.
    </p>
    <ul>
      <li>입문 코스 (Java 기초 / C / 데이터베이스 모델링): 주당 6~8시간</li>
      <li>응용 코스 (React / TypeScript): 주당 8~10시간</li>
      <li>심화 코스 (Java 심화 / AI 코딩): 주당 10시간 이상</li>
    </ul>
    <p>
      이는 정기 미팅 시간을 포함한 합산입니다. 시간이 부족한 주에는 멘토와 미리 조율해 진도를 늦추거나
      과제를 재구성합니다.
    </p>

    <h2>3. 준비물</h2>
    <ul>
      <li>본인 노트북 (운영체제 무관, 메모리 8GB 이상 권장)</li>
      <li>안정적인 인터넷 환경 (화상 미팅이 가능할 정도)</li>
      <li>GitHub 계정 (없다면 첫 미팅에서 함께 만듭니다)</li>
      <li>각 코스에 필요한 IDE / SDK는 첫 주에 안내드립니다 (전부 무료)</li>
    </ul>
    <p>
      별도의 유료 교재나 플랫폼 구독은 필요 없습니다. 모든 학습 자료는 멘토가 그때그때 정리해 드립니다.
    </p>

    <h2>4. 학습 단계</h2>
    <ol>
      <li>오리엔테이션 — 목표·일정·도구 환경 정리 (1주차)</li>
      <li>기본기 다지기 — 작은 함수·예제 단위로 손에 익히기 (2~3주차)</li>
      <li>미니 프로젝트 — 처음으로 끝까지 동작하는 결과물 만들기 (4~6주차)</li>
      <li>심화 프로젝트 — 포트폴리오에 올릴 만한 사이즈의 결과물 (7~10주차)</li>
      <li>회고와 정리 — 코드·문서·라이브 데모로 마무리 (마지막 주)</li>
    </ol>
    <p>
      위는 표준 흐름이며, 학생의 출발선과 목표에 따라 단축되거나 확장될 수 있습니다.
    </p>

    <h2>5. 잘 활용하는 팁</h2>
    <ul>
      <li>완벽한 코드보다 "동작하는 코드" 먼저 — 마무리 경험이 가장 큰 학습입니다.</li>
      <li>막힌 시간이 30분을 넘으면 멘토에게 질문 — 혼자 끙끙대지 마세요.</li>
      <li>주간 학습 일지를 가볍게라도 남기기 — 다음 주에 같은 실수를 반복하지 않습니다.</li>
      <li>AI 도구는 "초안 생성" 또는 "검토자"로 — 검증 없는 복붙은 학습이 되지 않습니다.</li>
    </ul>
  </LegalLayout>
);

export default LearningGuidePage;
